<template>
  <div class="button-container" :class="{ 'fondo-on': fondo }">
    <div class="container">
      <div :class="{ 'needle-on': isOn }" class="needle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOn: {
      type: Boolean,
      default: false,
    },
    fondo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.button-container {
  height: 100%;
  aspect-ratio: 1/1;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: #636262;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.needle {
  width: 4px;
  height: 20px;
  border-radius: 2px;
  background-color: lightgreen;
  transform-origin: center bottom;
  transition: transform 0.3s ease;
  transform: rotate(-30deg);
}

.needle-on {
  transform: rotate(30deg);
}

.fondo-on {
  background-color: rgb(114, 228, 114);
}
</style>
